import { type TableMeta } from "@tanstack/react-table";
import { type FC, useCallback, useMemo } from "react";

import { InputCheckbox } from "@moment/ui";

import { type DataGridColumnDef } from "../useColumnState";
import { ColumnHeaderLabel } from "./ColumnHeaderLabel";

export const StandardColumnOptions: FC<{
	headerID: string;
	columnDef: DataGridColumnDef<unknown, unknown>;
	updateColumn: TableMeta<unknown>["updateColumn"];
}> = ({ headerID, columnDef, updateColumn }) => {
	const fieldTypeInfo = useMemo(() => {
		return columnDef.fieldTypeInfo || {};
	}, [columnDef.fieldTypeInfo]);

	const changeReadonly = useCallback(
		(readonly: boolean) => {
			if (!updateColumn) {
				return;
			}

			const newColumnDef: DataGridColumnDef<unknown, unknown> = Object.assign({}, columnDef, {
				readonly,
			});

			updateColumn(headerID, newColumnDef);
		},
		[fieldTypeInfo, headerID, columnDef, updateColumn]
	);

	return (
		<div className="flex flex-col space-y-2">
			<div>
				<ColumnHeaderLabel htmlFor="column-readonly-checkbox">
					Column readonly
				</ColumnHeaderLabel>
			</div>
			<InputCheckbox
				id="column-readonly-checkbox"
				isSelected={columnDef.readonly}
				onChange={changeReadonly}
				size="sm"
			/>
		</div>
	);
};
